// Pure helpers for the owner catalog dialog (#263, #310), kept UI-free for unit tests.

/** Max upload we accept client-side (raw bytes). */
export const MAX_CATALOG_FILE_BYTES = 2_000_000;

/**
 * Raw file bytes → base64 for the JSON transport. Chunked so btoa never sees a call stack
 * containing every file byte at once (String.fromCharCode(...bigArray) overflows).
 */
export function bytesToBase64(bytes: Uint8Array): string {
  let binary = "";
  const CHUNK = 0x8000;
  for (let i = 0; i < bytes.length; i += CHUNK) {
    binary += String.fromCharCode(...bytes.subarray(i, i + CHUNK));
  }
  return btoa(binary);
}

/** Client-side pre-check: returns an i18n error key, or null when the file is acceptable. */
export function catalogFileError(file: { name: string; size: number }): string | null {
  if (file.size === 0) return "businesses.catalog.errEmpty";
  if (file.size > MAX_CATALOG_FILE_BYTES) return "businesses.catalog.errTooLarge";
  if (!/\.(csv|xlsx)$/i.test(file.name)) return "businesses.catalog.errNotCatalogFile";
  return null;
}
